<template>
  <main class="app-main">
    <section class="wam-content full-width" v-if="isDataStillLoading">
      <spinner class="l-flex-row--center l-align-center" width="200" height="200" />
    </section>
    <template v-else>
      <MarketPlace :disable-activate="disableActivate" @submit="activateClusters" />
    </template>
  </main>
</template>
<script>
// Components
import { mapState, mapActions, mapGetters } from 'vuex'
import MarketPlace from '@/components/marketPlace/MarketPlace'
import { isEmpty, includes, differenceWith, isEqual } from 'lodash'

export default {
    name: 'MarketPlaceWrapper',
    components: { MarketPlace },

    mounted() {
        if (isEmpty(this.secondPartyData)) this.retrieveItems({ all: true })
    },

    data() {
        return {}
    },

    computed: {
        ...mapState('data/secondParty', {
            secondPartyData: state => state.list,
            activeTaxoList: state => state.activeList,
            isLoading: state => state.isLoading
        }),
        ...mapState('ui/secondParty', {
            selectedClusters: state => state.selectedClusters,
            modifiedClusters: state => state.modifiedClusters
        }),
        ...mapGetters('ui/builder', ['criteriaListIsReady']),
        disableActivate() {
            return !(this.modifiedClusters.length > 0)
        },
        isDataStillLoading() {
            return !this.criteriaListIsReady || this.isLoading
        }
    },

    methods: {
        ...mapActions('data/secondParty', ['retrieveItems', 'requestSaveActivateClusters']),
        activateClusters() {
            let clusterList = {}
            const activeTaxoList = []
            let currentlyActiveTaxoList = []

            // giving the list of previously active taxos ids
            for (const provider in this.activeTaxoList) {
                for (const activeTaxo of this.activeTaxoList[provider].list) {
                    if (activeTaxo.account_status === 'active') activeTaxoList.push(activeTaxo.id)
                }
            }

            // adding ids that were not already added before
            for (const cluster in this.selectedClusters) {
                for (const id of this.selectedClusters[cluster]) {
                    currentlyActiveTaxoList = [...currentlyActiveTaxoList, id]
                    if (!includes(activeTaxoList, id)) clusterList = { ...clusterList, [id]: 'active' }
                }
            }

            // finding difference between currently active and previously active and remove those that are no longer active
            const difference = differenceWith(activeTaxoList, currentlyActiveTaxoList, !isEqual)
            for (const diff in difference) {
                clusterList = { ...clusterList, [difference[diff]]: 'inactive' }
            }
            const clustersParams = {
                second_party_clusters: clusterList
            }
            this.requestSaveActivateClusters(clustersParams)
        }
    }
}
</script>
